<template>
  <div class="itinerario-seccion-root" ref="itiSeccionRef">
    <!-- Contenedor de la foto superior sin espacios vacíos -->
    <div class="iti-portada-box">
      <img 
        src="@/assets/foto.webp" 
        alt="Boda Portada" 
        class="iti-img-foto" 
        ref="itiFotoRef" 
      />
    </div>

    <div class="itinerario-cuerpo">
      <h2 class="iti-main-title" ref="itiTitleRef">Itinerario</h2>

      <div class="iti-events-container">
        <div 
          v-for="(item, index) in eventos" 
          :key="index" 
          class="iti-event-card"
          ref="itiEventCardsRef"
        >
          <div class="iti-icon-wrapper">
            <img :src="item.icono" class="iti-event-icon" />
          </div>

          <div class="iti-content-wrapper">
            <h3 class="iti-event-title">{{ item.titulo }}</h3>
            <p class="iti-event-time">{{ item.hora }}</p>
          </div>

          <div v-if="index < eventos.length - 1" class="iti-spacer-line"></div>
        </div>

        <!-- Línea divisoria antes de la tornaboda -->
        <div class="iti-spacer-line iti-tornaboda-spacer" ref="itiTornaSpacerRef"></div>

        <!-- Sección Elegante de Tornaboda -->
        <div class="iti-tornaboda-container" ref="itiTornaBoxRef">
          <h3 class="iti-tornaboda-title">Tornaboda</h3>
          <p class="iti-tornaboda-fecha">Domingo 11 de Octubre</p>
          <p class="iti-tornaboda-hora"> Apartir de la 1:00 PM a 10:00 PM</p>
          <p class="iti-tornaboda-lugar">Quinta Atardecer</p>
          <p class="iti-tornaboda-nota">¡Te esperamos al día siguiente<br> en el mismo lugar!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'ItinerarioComponent',
  setup() {
    const itiSeccionRef = ref(null);
    const itiTitleRef = ref(null);
    const itiFotoRef = ref(null);
    const itiEventCardsRef = ref([]); 
    const itiTornaSpacerRef = ref(null);
    const itiTornaBoxRef = ref(null);

    const eventos = [
            { titulo: 'CEREMONIA RELIGIOSA', hora: '6:00 PM', icono: require('@/assets/ing.png') },

      { titulo: 'CEREMONIA CIVIL', hora: '8:30 PM', icono: require('@/assets/ceremonia.png') },
      { titulo: 'FIESTA', hora: '9:00 PM - 2:00 AM', icono: require('@/assets/fiest.png') }
    ];

    onMounted(() => {
      // 1. Animación de entrada para foto.webp
      gsap.fromTo(itiFotoRef.value, 
        { opacity: 0, scale: 1.08 },
        { opacity: 1, scale: 1, duration: 1.5, ease: "power2.out" }
      );

      // 2. Timeline Maestra con ScrollTrigger
      const itiTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: itiSeccionRef.value,
          start: "top 80%", 
          once: true
        }
      });

      // Animación consecutiva del título
      itiTimeline.fromTo(itiTitleRef.value, 
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: "power2.out" }
      );

      // Animación en cascada consecutiva para cada bloque del v-for
      if (itiEventCardsRef.value.length > 0) {
        itiEventCardsRef.value.forEach((card) => {
          const icon = card.querySelector('.iti-event-icon');
          const content = card.querySelector('.iti-content-wrapper');
          const spacer = card.querySelector('.iti-spacer-line');

          itiTimeline.fromTo(icon, 
            { scale: 0, opacity: 0, rotate: -10 },
            { scale: 1, opacity: 1, rotate: 0, duration: 0.5, ease: "back.out(1.5)" },
            "-=0.2"
          )
          .fromTo(content, 
            { y: 15, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.4, ease: "power2.out" },
            "-=0.2"
          );

          if (spacer) {
            itiTimeline.fromTo(spacer, 
              { scaleY: 0, opacity: 0 },
              { scaleY: 1, opacity: 1, duration: 0.4, transformOrigin: "top" },
              "-=0.1"
            );
          }
        });
      }

      // Animación consecutiva para el cierre de la Tornaboda
      itiTimeline.fromTo(itiTornaSpacerRef.value,
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 1, duration: 0.5 },
        "-=0.1"
      )
      .fromTo(itiTornaBoxRef.value,
        { y: 25, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: "power2.out" },
        "-=0.2"
      );
    });

    return { 
      eventos, 
      itiSeccionRef, 
      itiTitleRef, 
      itiFotoRef, 
      itiTornaSpacerRef,
      itiTornaBoxRef,
      itiEventCardsRef: (el) => { if (el) itiEventCardsRef.value.push(el) } 
    };
  }
}
</script>

<style scoped>
.itinerario-seccion-root {
  background-color: #fcfaf8;
  background-image: url("https://www.transparenttextures.com/patterns/cream-paper.png");
}

.iti-portada-box {
  width: 100%;
  height: 450px;
  overflow: hidden;
}

.iti-img-foto { 
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  display: block;
}

.itinerario-cuerpo {
  padding: 40px 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.iti-main-title {
  font-family: 'Playfair Display', serif;
  font-size: 3.2rem;
  letter-spacing: 2px;
  color: #5c4033; 
  margin-top: 20px;
  margin-bottom: 50px;
  font-weight: 500;
}

.iti-events-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
}

.iti-event-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
}

.iti-icon-wrapper {
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.iti-event-icon {
  width: 130px;
  height: 130px;
  object-fit: contain;
  filter: sepia(0.8) saturate(1.2) brightness(0.5) hue-rotate(340deg);
}

.iti-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.iti-event-title {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  letter-spacing: 2px;
  color: #2c2c2c;
  margin: 0;
  font-weight: 400;
}

.iti-event-time {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  font-weight: 600;
  color: #8c6d53; 
  margin: 0;
}

.iti-spacer-line {
  margin-top: 25px;
  width: 40px;
  height: 1px;
  background-color: #d1c4b9;
}

.iti-tornaboda-spacer {
  width: 100px; /* Un poco más ancha para separar la nueva sección */
  margin-top: 15px;
  margin-bottom: 15px;
}

/* Estilos específicos para la sección de la Tornaboda */
.iti-tornaboda-container {
  opacity: 0;
  text-align: center;
  padding: 10px 0;
  max-width: 400px;
}

.iti-tornaboda-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  color: #5c4033;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
  font-weight: 400;
}

.iti-tornaboda-fecha {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  letter-spacing: 1px;
  color: #2c2c2c;
  margin: 0 0 4px 0;
  font-weight: 500;
}

.iti-tornaboda-hora {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  font-weight: 600;
  color: #8c6d53;
  margin: 0 0 4px 0;
}

.iti-tornaboda-lugar {
  font-family: 'Playfair Display', serif;
  font-size: 19px !important;
  font-weight: bold;
  color: #2c2c2c;
  margin: 0 0 8px 0;
}

.iti-tornaboda-nota {
  font-family: 'Playfair Display', serif;
  font-size: 20px !important;
  font-style: italic;
  color: #6e6e6e;
  margin: 0;
}

@media (max-width: 600px) {
  .iti-portada-box { height: 320px; }
  .iti-main-title { font-size: 2.5rem; margin-bottom: 35px; }
  .iti-event-icon { width: 110px; height: 110px; }
  .iti-event-title { font-size: 13px; }
  .iti-tornaboda-title { font-size: 1.8rem; }
}
</style>